import * as React from "react";
import { Path, G, ClipPath, Defs, Rect, Ellipse } from "react-native-svg";

import { Icon, IconProps } from "../../primitive";

export const KEIcon = (props: IconProps) => (
  <Icon fill="none" viewBox="0 0 16 12" title="KE" {...props}>
    <G clipPath="url(#a)">
      <Rect width={16} height={12} fill="#fff" rx={1} />
      <Path
        fill="#0067C3"
        fillRule="evenodd"
        d="M0 0h16v12H0V0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#272727"
        fillRule="evenodd"
        d="M0 0v4h16V0H0Z"
        clipRule="evenodd"
      />
      <Path
        fill="#4E8B1D"
        fillRule="evenodd"
        d="M0 8v4h16V8H0Z"
        clipRule="evenodd"
      />
      <Path fill="#E31D1C" stroke="#F7FCFF" d="M16.5 3.5v5h-17v-5h17Z" />
      <Ellipse cx={8} cy={6} fill="#AC2317" rx={2} ry={4} />
      <Path
        fill="#fff"
        d="M9.812 2.015c.114-.205.42-.43.92-.672a.068.068 0 0 1 .056-.002c.03.013.043.045.028.07l-5.179 9.315-.27-.116L9.932 2.4c-.206-.03-.246-.158-.12-.385Z"
      />
      <Path
        fill="#fff"
        d="M6.183 2.015c.126.227.086.356-.12.385l4.564 8.21-.27.116L5.18 1.412c-.015-.026-.003-.058.027-.07a.068.068 0 0 1 .056 0c.5.244.807.468.92.673Z"
      />
      <Path
        fill="#000"
        d="M9.69 3.87c.195.617.31 1.347.31 2.13a7.16 7.16 0 0 1-.31 2.13A3.663 3.663 0 0 1 9 6c0-.782.253-1.513.69-2.13ZM6.309 3.87C6.746 4.488 7 5.219 7 6c0 .783-.254 1.513-.691 2.13A7.163 7.163 0 0 1 6 6c0-.782.114-1.513.309-2.13Z"
      />
      <Path
        fill="#F7FCFF"
        d="M8.12 6.352c.274.171.48.915.48 1.806 0 .89-.206 1.634-.48 1.805v-3.61Zm-.3 3.563c-.243-.235-.42-.933-.42-1.757 0-.825.176-1.524.42-1.759v3.516Zm.3-7.825c.274.17.48.913.48 1.804S8.394 5.53 8.12 5.7V2.09Zm-.3 3.562c-.243-.235-.42-.933-.42-1.758s.176-1.523.42-1.758v3.516Z"
      />
      <Path
        fill="#F7FCFF"
        d="M8 5.737c.331 0 .6.236.6.526 0 .29-.269.527-.6.527-.331 0-.6-.236-.6-.527 0-.29.269-.526.6-.526Z"
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Rect width={16} height={12} fill="#fff" rx={1} />
      </ClipPath>
    </Defs>
  </Icon>
);
